import { DossierDetailsContent, DossierDetailsHeader, DossierDetailsPanel } from "@/app/pages/dossier/dossier-details-panel.tsx";
import { useGetDossierEvaluatieById } from "@/entities/evaluatie";
import { RoleGate, UserRole } from "@/features/auth";
import { useDossierId } from "@/features/dossier-details";
import { ErrorDisplay, Skeleton, Tabs, TabsContent, TabsList, TabsTrigger } from "@/shared/components";
import { useArchiveVisibility } from "@/shared/hooks";
import { KHREvaluatie } from "./KHR-evaluatie";
import { BusinzetEvaluatie } from "./businzet-evaluatie";

export function EvaluatieDetails() {
    const id = useDossierId();
    const isArchived = useArchiveVisibility();

    const { data: evaluatie, isPending, error, refetch } = useGetDossierEvaluatieById(id);

    if (isPending) {
        return (
            <DossierDetailsPanel data-testid="evaluatie-details-skeleton">
                <DossierDetailsHeader section="Evaluatie" showBackButton />
                <DossierDetailsContent className="px-4">
                    <div className="flex flex-col gap-4">
                        <h2 className="text-l leading-m text-content-emphasis font-medium">Klanthinderrapportage (KHR)</h2>
                        <ol className="grid gap-4">
                            <Skeleton className="h-14 w-full" />
                            <Skeleton className="h-14 w-full" />
                            <Skeleton className="h-14 w-full" />
                            <Skeleton className="h-14 w-full" />
                        </ol>
                    </div>
                </DossierDetailsContent>
            </DossierDetailsPanel>
        );
    }

    if (error) {
        return (
            <DossierDetailsPanel testId="evaluatie-details-error">
                <DossierDetailsHeader section="Evaluatie" showBackButton />
                <DossierDetailsContent>
                    <ErrorDisplay
                        error={error}
                        variant="section"
                        title="Fout bij het laden van de evaluatie"
                        onRetry={() => window.location.reload()}
                    />
                </DossierDetailsContent>
            </DossierDetailsPanel>
        );
    }

    return (
        <DossierDetailsPanel>
            <DossierDetailsHeader section="Evaluatie" showBackButton />
            <DossierDetailsContent>
                <div>
                    <Tabs defaultValue="khr" className="gap-0" onValueChange={() => void refetch()}>
                        <TabsList>
                            <TabsTrigger value="khr" className="relative">
                                KHR
                            </TabsTrigger>
                            <RoleGate roles={[UserRole.REGIEVOERDER]}>
                                <TabsTrigger value="businzet">Businzet</TabsTrigger>
                            </RoleGate>
                        </TabsList>
                        <TabsContent value="khr">
                            <RoleGate roles={[UserRole.REGIEVOERDER]}>
                                <KHREvaluatie dossierId={id} evaluatie={evaluatie} readOnly={isArchived} />
                            </RoleGate>
                            <RoleGate roles={[UserRole.SUPPORTCONSULTANT, UserRole.ALLEENLEZEN]}>
                                <KHREvaluatie dossierId={id} evaluatie={evaluatie} readOnly />
                            </RoleGate>
                        </TabsContent>
                        <RoleGate roles={[UserRole.REGIEVOERDER]}>
                            <TabsContent value="businzet">
                                <BusinzetEvaluatie dossierId={id} evaluatie={evaluatie} />
                            </TabsContent>
                        </RoleGate>
                    </Tabs>
                </div>
            </DossierDetailsContent>
        </DossierDetailsPanel>
    );
}
